/**
 * @generated SignedSource<<3098c7fbe6c490bcf72204b03ad275fd>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useSuggestToolMutation$variables = {
  prompt: string;
};
export type useSuggestToolMutation$data = {
  readonly suggestOnboardingSolution: {
    readonly alternativeToolIds: ReadonlyArray<string>;
    readonly toolId: string;
  };
};
export type useSuggestToolMutation = {
  response: useSuggestToolMutation$data;
  variables: useSuggestToolMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "prompt"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "prompt",
        "variableName": "prompt"
      }
    ],
    "concreteType": "OnboardingSuggestion",
    "kind": "LinkedField",
    "name": "suggestOnboardingSolution",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "toolId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "alternativeToolIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSuggestToolMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useSuggestToolMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "d511245718f5584acbd73d0aa601e6e1",
    "id": null,
    "metadata": {},
    "name": "useSuggestToolMutation",
    "operationKind": "mutation",
    "text": "mutation useSuggestToolMutation(\n  $prompt: String!\n) {\n  suggestOnboardingSolution(prompt: $prompt) {\n    toolId\n    alternativeToolIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "56a4e57812e3ea8f99db1de32d3d171c";

export default node;
